import { RECEIVE_OUTLINES, SET_OUTLINE_IS_ACTIVE, TOGGLE_OUTLINE_IS_COLLAPSED } from './outline.actions';

export interface IOutlineState {
  anchor: string,
  id: string,
  level: number
  tag: string,
  text: string,
  children: IOutlineState[],
  isActive: boolean,
  isCollapsed: boolean,
}

const outlinesInitialState: IOutlineState[] = [];

export function outlineReducer(state = outlinesInitialState, action: any) {
  switch (action.type) {
    case RECEIVE_OUTLINES:
      const outlines = action.outlines.map((outline) => {
        outline.children = [];
        outline.isActive = false;

        if(!outline.level) {
          outline.isCollapsed = true;
        } else {
          outline.isCollapsed = false;
        }
        return outline;
      });
      return Object.assign({}, outlines);
    case SET_OUTLINE_IS_ACTIVE:
      const id = action.id;
      const isActive = action.isActive;
      let modifiedOutlines = Object.values(state);
      modifiedOutlines = modifiedOutlines.map((outline) => {
        outline.children = [];
        if(outline.id == id) {
          outline.isActive = isActive;
        } else {
          if(isActive) {
            outline.isActive = false;
          }
        }
        return {...outline};
      })
      return Object.assign({}, {...modifiedOutlines});
    case TOGGLE_OUTLINE_IS_COLLAPSED:
      modifiedOutlines = Object.values(state).map((outline) => {
        if(outline.id == action.outlineId) {
          if(outline.isCollapsed) {
            outline.isCollapsed = false;
          } else {
            outline.isCollapsed = true;
          }
        }
        return {...outline};
      });
      return Object.assign({}, modifiedOutlines);
    default:
      return state;
  }
}
